import React, { useEffect, useState } from 'react';
import { Drawer, Box } from '@mui/material';
import SideNav from '../../SideNav';

const DrawerExtend = () => {
    const [drawerHeight, setDrawerHeight] = useState(window.innerHeight);

    const updateDrawerHeight = () => {
        const documentHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
        );

        setDrawerHeight(documentHeight);
    };

    useEffect(() => {
        updateDrawerHeight();
        window.addEventListener('scroll', updateDrawerHeight);
        return () => {
            window.removeEventListener('scroll', updateDrawerHeight);
        };
    }, []);

    return (
        <Drawer
            variant="permanent"
            sx={{
                display: { xs: 'none', md: 'block' },
                zIndex: 1,
                [`& .MuiDrawer-paper`]: { 
                    width:  { md: '16vw', lg: '12vw' }, 
                    boxSizing: 'border-box', 
                    zIndex: 1, 
                    position: 'absolute', 
                    height: drawerHeight, // Dynamically set height
                    overflow: 'auto', 
                },
            }}
        >
            <SideNav />
        </Drawer>
    );
};

export default DrawerExtend;